import type { StepProps } from "../app";
import { track } from "../lib/analytics";
import { ContactExpert } from "../ContactExpert";

export function Step1Contact({ state, update, next, back, stepName }: StepProps) {
  const valid =
    state.firstName && state.lastName && state.email && state.phone &&
    state.street && state.city && state.state && state.zip && state.contactConsent;

  // The lead moment: contact details captured with consent. GA4-recommended
  // `generate_lead` so it works as a conversion / audience seed in Google Ads.
  const onContinue = () => {
    track("generate_lead", { submission_id: state.submissionId, zip: state.zip });
    next();
  };

  return (
    <section class="step">
      <h2>Where should we send your quote?</h2>
      <div class="grid">
        <label>First name<input autocomplete="given-name" value={state.firstName} onInput={(e) => update({ firstName: e.currentTarget.value })} /></label>
        <label>Last name<input autocomplete="family-name" value={state.lastName} onInput={(e) => update({ lastName: e.currentTarget.value })} /></label>
        <label>Email<input type="email" autocomplete="email" inputMode="email" value={state.email} onInput={(e) => update({ email: e.currentTarget.value })} /></label>
        <label>Phone<input type="tel" autocomplete="tel" inputMode="tel" value={state.phone} onInput={(e) => update({ phone: e.currentTarget.value })} /></label>
        <label class="span2">Street<input autocomplete="street-address" value={state.street} onInput={(e) => update({ street: e.currentTarget.value })} /></label>
        <label>City<input autocomplete="address-level2" value={state.city} onInput={(e) => update({ city: e.currentTarget.value })} /></label>
        <label>State<input autocomplete="address-level1" value={state.state} maxLength={2} onInput={(e) => update({ state: e.currentTarget.value.toUpperCase() })} /></label>
        <label>ZIP<input autocomplete="postal-code" inputMode="numeric" value={state.zip} onInput={(e) => update({ zip: e.currentTarget.value })} /></label>
      </div>
      <label class="check consent">
        <input
          type="checkbox"
          checked={state.contactConsent}
          onChange={(e) => update({ contactConsent: e.currentTarget.checked })}
        />
        I agree that Kasselman Solar may contact me about my quote by phone, text, or email.
      </label>
      <div class="actions">
        <button onClick={back}>Back</button>
        <ContactExpert stepName={stepName} submissionId={state.submissionId} />
        <button class="primary" disabled={!valid} onClick={onContinue}>Continue</button>
      </div>
    </section>
  );
}
